
import { toTitleCase } from "../../../../utilities/functions";
import styles from "./AttributeColumn.module.css"
const AttributeColumn = (props) => {
    const data = props.data;
    return (
        <div className={styles.AttributeColumn}>                
                <h6><a href={data?.product_url} target="_blank" rel="noreferrer">{data?.sku_name}</a></h6>
                <span><strong>Brand:</strong> {data?.brand?.length > 0 ? data?.brand : "No brand found"}</span>
                <span><strong>Price:</strong> {data?.price?.length > 0 || typeof(data?.price) === "number" ? data?.price : "No price found"}</span>
                <span><strong>Retailer:</strong> {toTitleCase(data?.search_banner?.replace(/_/g, " "))}</span>
                {data?.pack_size && <span><strong>Pack Size:</strong> {data?.pack_size}</span>}
                {data?.pack_volume && <span><strong>Pack Volume:</strong> {data?.pack_volume}</span>}
        </div>

    )
};

export default AttributeColumn;